'use strict';

var Dominus = require('./Dominus.ctor');

function flatten (a, cache) {
  return a.reduce(function (current, item) {
    if (Dominus.isArray(item)) {
      return flatten(item, current);
    } else if (current.indexOf(item) === -1) {
      return current.concat(item);
    }
    return current;
  }, cache || new Dominus());
}

module.exports = flatten;



/*****************
 ** WEBPACK FOOTER
 ** ./~/dominus/src/flatten.js
 ** module id = 39
 ** module chunks = 0
 **/